/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function GitBranch({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M3.5 1.5v9" /><path stroke="currentColor" strokeWidth={1.2} d="M5.5 12.5c3.9 0 7-3.1 7-7" /><circle cx={3.5} cy={12.5} r={2} stroke="currentColor" strokeWidth={1.2} /><circle cx={12.5} cy={3.5} r={2} stroke="currentColor" strokeWidth={1.2} /></svg>;
}
;